import { clsx } from "clsx";
import { CircleAlert } from "lucide-react";
import { Link, useParams } from "react-router";

import { Button } from "@/components/ui/button";
import { usePendingAttendance } from "../../hooks/use-pending-attendance";
import {
	firstPendingDate,
	pendingBannerText,
	pendingFillPath,
} from "../../utils/pending";

export function PendingBanner({
	compact = false,
	className,
}: {
	compact?: boolean;
	className?: string;
}) {
	const { obra: obraKey } = useParams();
	const { data } = usePendingAttendance();

	if (!data || data.count === 0) return null;

	return (
		<div
			className={clsx("pending-banner", className)}
			data-count={data.count}
			data-variant={compact ? "compact" : undefined}
			role="status"
		>
			<CircleAlert className="pending-banner__icon" aria-hidden="true" />
			<p className="pending-banner__text">{pendingBannerText(data.count)}</p>
			<Button
				asChild
				size="sm"
				variant={compact ? "outline" : "default"}
				className="pending-banner__action"
			>
				<Link
					to={pendingFillPath(obraKey ?? "", firstPendingDate(data.workers))}
				>
					Preencher agora
				</Link>
			</Button>
		</div>
	);
}
